<template>
        <div class="overHidden" style="margin-top: 5px;">
                
                <el-tooltip class="content" :effect="effect" :content="content" :placement="placement">
                        <div class="showContent" :style="'-webkit-line-clamp:'+rowNum">
                                <slot></slot>
                        </div>
                </el-tooltip>
        </div>
</template>
<script>
export default {
        props:{
                // 主题
                effect:{
                        type:String,
                        default:'dark'
                },
                // 展示效果
                placement:{
                        type:String,
                        default:'top'
                },
                // 展示内容
                content:{
                        type:String,
                        default:'top'
                },
                // 展示行数
                rowNum:{
                        type:Number,
                        default:2
                },
        },
        data(){
                return{

                }
        }
}
</script>
<style lang="scss" scoped>
        .overHidden{
                .content{
                        // max-width: 240px;
                }
                .showContent{
                        overflow:hidden; 

                        text-overflow:ellipsis;

                        display:-webkit-box; 

                        -webkit-box-orient:vertical;

                        // -webkit-line-clamp:2;  
                }
        }
</style>